import { boolean, object, string } from 'yup';

export const siv = /(^[A-Z]{2}\d{3}[A-Z]{2}$)|(^[A-Z]{1,2}\d{3}[A-Z]$)|(^(\d{1,4})([A-Z]{2,3})(\d[0-9AB])$)|(^(([0-9A-Z]{4})|([A-Z]\d{3})|(\d{3}[A-Z])|([A-Z]{2}\d{2}))$)/g;

export const registrationValidationSchema = object().shape({
  immatriculation: string().required('Champ obligatoire'),
  vin: string().required('Le vin est obligatoire'),
  autorisation: boolean().oneOf([true], 'Veuillez accepter les informations légales'),
});

export const registrationProValidationSchema = object().shape({
  autorisation: boolean().oneOf([true], 'Veuillez accepter les informations légales'),
});
